enum ComboboxSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export default ComboboxSize;
